<div [formGroup]="clearanceItemForm">
  <div class="input-field col l12 s12" *ngIf="canTagBeChanged() && allowCreateTag">
    <div class="tags col l12 s12">
      <div class="input-field col l12 s12 m12 tag-mat-search-wrap">
        <mat-form-field appearance="fill" floatLabel="always" class="tag-search-field">
          <mat-label>Search tags</mat-label>
          <input
            #tagSearchElement
            matInput
            type="text"
            maxlength="80"
            [formControl]="tagSearchControl"
            [matAutocomplete]="tagAuto"
            (keyup.enter)="addCustomTag(tagSearchControl.value)"
            placeholder="If not available hit ENTER to create a new tag1">
          <mat-autocomplete
            #tagAuto="matAutocomplete"
            panelClass="clearance-tag-autocomplete-panel"
            (optionSelected)="onTagAutocompleteSelected($event)">
            <mat-option *ngFor="let name of filteredTagNames" [value]="name">{{ name }}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="tag-chips-row">
    <div class="form-group tag-chips-form" formArrayName="tags">
        <div class="tags tag-chip-cell" *ngFor="let tag of tagsControls; let i = index">
          <div
            [formGroupName]="i"
            class="content"
            [ngClass]="{ 'selected': tag.controls.isSelected.value, 'disabled-anchor': !canTagBeChanged() }"
            (click)="canTagBeChanged() && togleTagSelection(tag)">
            <div class="center">
              {{ tag.controls.tagName.value }}
              <mat-icon
                class="material-icons right tag-delete-icon"
                *ngIf="isClearanceUser && tag.controls.tagType.value === 'Custom'"
                (click)="deleteCustomTag(tag, $event)">delete</mat-icon>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>
